(() => {
  const start = () => {
    const main = document.getElementById('MainContent');
    if (!main || !document.body.classList.contains('template-index')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const selectors = [
      '.sdj-copy > *',
      '[class*="ai-editorial-statement__container"]',
      '.sdj-no-list__visual',
      '.sdj-no-list__copy p',
      '.sdj-polaroids__eyebrow',
      '.sdj-polaroids__inner > h2',
      '.sdj-polaroid',
      '.sdj-reviews__header > *',
      '.sdj-review-card',
      '.sdj-french-journey__header > *',
      '.sdj-french-journey__step',
      '.sdj-section-cta-wrap',
      '.sdj-footer__brand',
      '.sdj-footer__nav',
      '.sdj-footer__newsletter'
    ];
    const elements = [...new Set([...main.querySelectorAll(selectors.join(',')), ...document.querySelectorAll('.sdj-footer ' + ['.sdj-footer__brand','.sdj-footer__nav','.sdj-footer__newsletter'].join(',.sdj-footer '))])];
    elements.forEach((el, index) => {
      el.classList.add('sdj-reveal');
      const localIndex = [...(el.parentElement?.children || [])].indexOf(el);
      el.style.setProperty('--sdj-delay', Math.max(0, localIndex % 4) * 90 + 'ms');
      if (el.matches('.sdj-polaroid,.sdj-review-card,.sdj-french-journey__step,[class*="ai-editorial-statement__container"]')) el.dataset.sdjReveal = 'scale';
      if (el.matches('.sdj-no-list__visual')) el.dataset.sdjReveal = 'left';
      if (el.matches('.sdj-no-list__copy p')) el.dataset.sdjReveal = 'right';
    });
    document.documentElement.classList.add('sdj-motion-ready');
    if (reduce || !('IntersectionObserver' in window)) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    elements.forEach(el => observer.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();